export const DRIVER_PUSH_CHANNEL_ID = "driver_alerts_v2";

export const PUSH_CHANNELS = [
  {
    id: DRIVER_PUSH_CHANNEL_ID,
    name: "REISOR PRO",
    description: "REISOR driver notifications and new freight alerts",
    importance: 5,
    visibility: 1,
    vibration: true,
  },
];
